<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Members - Change Order</div>
                  <p>You can change members list ordering by drag and drop !</p>
                </div>
              <div class="col-md-2 offset-md-3 text-right center">
                <router-link to="/admin/persons" class="btn btn-primary" role="button">
                  back
                </router-link>
              </div>
            </div>

          <div class="table-responsive text-center">
            <table class="table table-light table-bordered table-hover">
              <draggable v-model="persons.data" @start="drag=true" @end="drag=false">
                <tr v-for="(item, index) in persons.data" :key="index">
                  <!--<td>{{item.displayOrder}}</td>-->
                  <td>{{item.staffId}}</td>
                  <td>{{item.memberFirstName}}</td>
                  <td><img class="table-thumbnail" :title="item.memberFirstName":src="item.memberImageUrl" /></td>
                  <td>{{item.position}}</td>
                  <td>
                    <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                    <span class="badge badge-danger" v-else> Inactive </span>
                  </td>
                </tr>
              </draggable>
            </table>
          </div>

          <div class="offset-md-3 col-md-6 text-center">
            <button class="btn btn-primary btn-fill btn-block" @click="updatePersonListing">
              Update listings order
            </button>
          </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import draggable from 'vuedraggable'
    const personsColumns = ['Member Id', 'Member Name','Image', 'Designation', 'Status', 'Operations'];
    export default {
        name: 'PersonOrder',
        components: {
            LTable,
            draggable,
        },
        data() {
        return {
            persons: {
        data: []
    }
    }
    },
    methods: {
      updatePersonListing () {
          let data = this.persons.data;
          let personIds = data.map((obj) => {
            return obj.staffId
          });
          this.$store.dispatch('UPDATE_PERSONS_ORDERING', {dispOrderStaffIds: personIds})
            .then((res) => {
              console.log("UPDATE_EXPERTS_ORDERING API res : ", res);
              this.$swal('Success!', 'Display order updated successfully', 'success');
              this.$router.push('/admin/persons')
            })
            .catch(err => {
              console.log("UPDATE_EXPERTS_ORDERING API error : ", err);
            })
        },
      fetchPersons () {
        this.$store.dispatch('FETCH_PERSONS')
          .then((res) => {
            console.log('res', res)
            this.persons.data = res;
          })
          .catch(err => {
            console.log("API error : ", err);
          })
          , (err) => {
          console.log("err : ", err);
        }
      },
    },
    created() {
        this.fetchPersons();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Persons/OrderPersons.vue